import React from 'react';

import { createHashRouter } from 'react-router-dom';
import Layout from '../components/Layout';
import Devices from '../routes/Devices';
import EditDeviceForm from '../routes/EditDeviceForm';
import EditObjectForm from '../routes/EditObjectForm';
import ErrorPage from '../routes/ErrorPage';
import NewDeviceForm from '../routes/NewDeviceForm';
import NewObjectForm from '../routes/NewObjectForm';
import Objects from '../routes/Objects';
import ObjectMap from '../routes/ObjectMap';
import Analytics from '../routes/Analytics';
import SingleObjectMap from '../routes/SingleObjectMap';
import Settings from '../routes/Settings';

const router = createHashRouter([
    {path: '/', element: <Layout />, children: [
      {index: true , element: <Objects /> },
      {path: 'objects/new', element: <NewObjectForm />},
      {path: 'objects/:objectId', element: <EditObjectForm />},
      {path: 'devices', element: <Devices />},
      {path: 'devices/:deviceId', element: <EditDeviceForm />},
      {path: 'devices/new', element: <NewDeviceForm />},
      {path: 'analytics', element: <Analytics />},
      {path: 'map', element: <ObjectMap />},
      {path: 'map/:objectId', element: <SingleObjectMap />},
      {path: 'settings', element: <Settings />},
      {path: '*', element: <ErrorPage msg='Page not found' />},
    ]},
  ])

export default router;